import { FunctionComponent, PropsWithChildren } from "react";
import styles from "./fieldset-block.module.scss";

type FieldsetBlockProps = {
  title: string;
  className?: string;
};

const FieldsetBlock: FunctionComponent<
  PropsWithChildren<FieldsetBlockProps>
> = ({ title, className = styles.fieldsetBlock, children }) => (
  <fieldset className={className}>
    <legend className={styles.legend}>{title}</legend>
    {children}
  </fieldset>
);

export default FieldsetBlock;
